import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import "./Loading.css"


export default function CircularLoading() {
  return (
    <div id='mainScreen'>

    <Box sx={{ display: 'flex'  }}>
      <CircularProgress />
    </Box>
    </div>
  );
}